<template>
    <div class="medal-block">
        <div class="medals">
            <div class="medal silver" :class="{won: isType( 'narrow-frame' ) }"></div>
            <div class="medal gold" :class="{won: isType( 'moderate-frame' ) }"></div>
            <div class="medal platinum" :class="{won: isType( 'broad-frame' ) }"></div>
        </div>
        <div class="label">Your Result<strong>{{medalType}}</strong></div>
    </div>
</template>

<script>
    // import { gsap } from '/src/assets/js/gsap'
    import slugify from '/src/assets/js/slugify.js'

    export default {
        name : "Medal2",
        props: {
            medalType: String,
        },
        computed : {
            slug(){
                return slugify( this.medalType )
            }
        },
        methods : {
            isType( val ){
                return this.slug === val
            }
        }
    }
</script>